import { TextField, TextFieldProps } from '@mui/material';
import { FunctionComponent } from 'react';

export const Select: FunctionComponent<TextFieldProps> = ({
    children,
    ...props
}) => {
    return (
        <TextField
            {...props}
            SelectProps={{ native: true }}
            fullWidth
            select
            autoComplete='off'
        >
            {children}
        </TextField>
    );
};
